import { useQuery } from '@tanstack/react-query'
import { queryClient } from '../App'
import { getImpossibleReasons } from '../services/CustomerApiService'

export const useImpossibleReasons = () => {
  return useQuery(
    {
      queryKey: ['impossible-reasons'],
      queryFn: () => getImpossibleReasons(),
      staleTime: 1000000,
      placeholderData: [],
    },
    queryClient,
  )
}
